import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist} from "../../../Services/BrowserDatabaseFunctions";


export function setAllContacts(_contacts){
    console.log('Setting all Contacts');

    return openDb('pa', 1, ensureStoresExist).then(function (db) {
        const tx = db.transaction('Contacts', 'readwrite');
        const store = tx.objectStore('Contacts');

        // Clear everything in the Contacts store
        return store.clear()
            .then(() => {
                const contactsArray = Array.isArray(_contacts) ? _contacts : [];

                // Insert each contact as its own record by id (inline keyPath)
                const ops = contactsArray.map(contact => {
                    if (!contact || contact.id == null) {
                        console.warn('Skipping contact without id:', contact);
                        return Promise.resolve(); // skip invalid contacts
                    }
                    // keyPath is "id", so do NOT pass key as second arg
                    return store.put(contact);
                });

                return Promise.all(ops);
            })
            .then(() => {
                console.log('All Contacts replaced successfully.');
                return true;
            });
    }).catch(error => {
        console.error("An error occurred while setting Contacts:", error);
        throw error;
    });
}

export function getAllContactsFromDatabase(){
    console.log('Fetching all contacts from Contacts');

    return openDb('pa', 1, ensureStoresExist).then(function (db) {
        const tx = db.transaction('Contacts', 'readonly');
        const store = tx.objectStore('Contacts');

        // return all Contacts
        return store.getAll();
    }).catch(error => {
        console.error("An error occurred while fetching Contacts:", error);
        throw error;
    });
}

export function updateContactsInDatabase(contactsArray) {
    console.log("updateContactsInDatabase : ", contactsArray);

    return openDb("pa", 1, ensureStoresExist).then(db => {
        // Use a wrapping Promise to manage the transaction lifecycle
        return new Promise((resolve, reject) => {
            const tx = db.transaction("Contacts", "readwrite");
            const store = tx.objectStore("Contacts");

            const updatePromises = []; // Array to hold Promises for each RMW cycle

            for (const contact of contactsArray) {
                const key = contact.id;

                // 1. Create a Promise for the individual Read-Modify-Write cycle
                const rmwPromise = new Promise((resolveRMW, rejectRMW) => {

                    // 💡 FIX 1: Use the Promise syntax (.then) on the wrapped request
                    const getReqPromise = store.get(key);

                    // You see this log because it's synchronous (the Promise object is created):
                    console.log("getReq : ", getReqPromise);

                    getReqPromise
                        .then(existing => {
                            // This is the SUCCESS handler, receiving the result directly
                            console.log("getReq.onsuccess");

                            const merged = existing
                                ? Object.assign({}, existing, contact)
                                : contact;

                            console.log("merged : ", merged);

                            // 2. Schedule the PUT request (assuming store.put also returns a Promise)
                            const putReqPromise = store.put(merged);

                            putReqPromise
                                .then(() => {
                                    console.log("putReq.onsuccess:");
                                    resolveRMW(true); // Resolve the RMW Promise on put success
                                })
                                .catch(putError => {
                                    console.error("PUT ERROR:", putError);
                                    rejectRMW(putError); // Reject the RMW Promise on put error
                                });
                        })
                        .catch(getError => {
                            // This is the ERROR handler
                            console.error("GET ERROR:", getError);
                            rejectRMW(getError); // Reject the RMW Promise on get error
                        });
                });

                console.log("rmwPromise:", rmwPromise);
                updatePromises.push(rmwPromise);
            }




            console.log("updatePromises:", updatePromises);

            // 3. Wait for all RMW Promises to complete
            Promise.all(updatePromises)
                .then(() => {
                    console.log("updatePromises:"); // This will now print!
                    // All requests are scheduled; return the transaction's own complete event
                    tx.oncomplete = () => resolve(true);
                    tx.onerror = () => reject(tx.error);
                    tx.onabort = () => reject(tx.error);
                })
                .catch(err => {
                    // If any RMW fails, abort the transaction and reject the main Promise
                    tx.abort();
                    reject(err);
                });
        });
    });
}

export function updateSpecificContactInDatabase(contactData) {
    console.log("updateSpecificContactInDatabase for ID:", contactData.id);

    const attendeeId = contactData.id;

    if (!attendeeId) {
        console.error("updateSpecificContactInDatabase: 'id' is required.");
        return Promise.reject(new Error("'id' field is missing."));
    }

    // Shallow clone to avoid mutating the original
    const incomingFields = { ...contactData };

    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Contacts", "readwrite");
            const store = tx.objectStore("Contacts");

            // Get the existing contact by its id (keyPath is "id")
            return store.get(attendeeId).then(existingContact => {
                if (!existingContact) {
                    console.error(`Contact with ID ${attendeeId} not found in IndexedDB.`);
                    return false;
                }

                // Merge existing data with incoming fields (incoming wins)
                const updatedContact = {
                    ...existingContact,
                    ...incomingFields,
                };

                // For inline keyPath "id", DO NOT pass an explicit key
                return store.put(updatedContact).then(() => {
                    console.log(`Contact with ID ${attendeeId} updated successfully.`);
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred during updateSpecificContactInDatabase:", error);
            throw error;
        });
}


export function removeAllContactsFromDatabase() {
    return openDb('pa', 1, ensureStoresExist).then(function(db) {
        const tx = db.transaction('Contacts', 'readwrite');
        const store = tx.objectStore('Contacts');

        // Delete any contents in the Contacts array
        store.clear();

        // 3. Wait for the transaction to finish and commit
        return tx.complete;
    }).then(function() {
        console.log('Events removed from Contacts store.');
    }).catch(function(error) {
        console.error('An error occurred while removing contacts:', error);
        throw error; // Re-throw the error to be caught by the caller
    });
}
